import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PilesPage = () => (
  <>
    <Header />
    <main className="py-12 bg-swastik-lightEarth/40 min-h-screen">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-3xl md:text-4xl font-bold text-swastik-blue mb-6">Natural Herbal Treatment for Piles</h1>
        <section className="mb-8">
          <p>Piles (hemorrhoids) are swollen veins in the anal region that can cause discomfort and pain. Our natural therapies focus on reducing inflammation, improving blood circulation, and promoting healing through gentle, effective herbal remedies and lifestyle modifications.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Causes</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Chronic constipation</li>
            <li>Straining during bowel movements</li>
            <li>Pregnancy</li>
            <li>Obesity</li>
            <li>Sedentary lifestyle</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Symptoms</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Pain and discomfort</li>
            <li>Bleeding during bowel movements</li>
            <li>Itching and irritation</li>
            <li>Swelling around anus</li>
            <li>Lump near anus</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Our Herbal Approach</h2>
          <p>We use anti-inflammatory herbs, blood circulation enhancers, and lifestyle modifications to naturally treat piles. Our approach focuses on reducing swelling, improving blood flow, and promoting healing through personalized treatment plans.</p>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Benefits of Herbal Treatment</h2>
          <ul className="list-disc list-inside ml-4">
            <li>Natural pain relief</li>
            <li>Reduced inflammation</li>
            <li>No harsh side effects</li>
            <li>Long-term management</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Lifestyle Recommendations</h2>
          <ul className="list-disc list-inside ml-4">
            <li>High-fiber diet</li>
            <li>Regular exercise</li>
            <li>Proper hydration</li>
            <li>Avoid straining during bowel movements</li>
          </ul>
        </section>
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-2">Frequently Asked Questions</h2>
          <div className="mb-4">
            <strong>Q1: How long does it take to see improvement?</strong>
            <p>A: Many patients notice improvement within 2-4 weeks of consistent treatment.</p>
          </div>
          <div className="mb-4">
            <strong>Q2: Is this treatment safe for long-term use?</strong>
            <p>A: Yes, our natural remedies are gentle and suitable for long-term management of piles.</p>
          </div>
          <div className="mb-4">
            <strong>Q3: Can this treatment prevent recurrence?</strong>
            <p>A: Yes, our holistic approach helps prevent recurrence by addressing underlying causes.</p>
          </div>
        </section>
        <section className="mb-8">
          <div className="bg-swastik-blue/10 p-6 rounded-lg text-center">
            <h3 className="text-xl font-semibold mb-2">Find relief from piles—book your natural treatment consultation today!</h3>
            <a href="/contact" className="inline-block mt-4 px-6 py-2 bg-swastik-blue text-white rounded hover:bg-swastik-blue/90 transition">Book Consultation</a>
          </div>
        </section>
      </div>
    </main>
    <Footer />
  </>
);

export default PilesPage; 